import { render, staticRenderFns } from "./EBankTab.vue?vue&type=template&id=70764006&"
import script from "./EBankTab.vue?vue&type=script&lang=js&"
export * from "./EBankTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70764006')) {
      api.createRecord('70764006', component.options)
    } else {
      api.reload('70764006', component.options)
    }
    module.hot.accept("./EBankTab.vue?vue&type=template&id=70764006&", function () {
      api.rerender('70764006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/tabs/EBankTab.vue"
export default component.exports